const EDeliveryMethod = Object.freeze({
  Disk: 0,
  Smtp: 10,
  SmtpCustomer: 12,
  SiBApi: 20,
  SiBApiCustomer: 22
});

export default EDeliveryMethod;
